import React from 'react'

import { InfoSection } from '../common'
import { useSearchParams } from "react-router-dom";

export const Greetings = () => {
  const [searchParams] = useSearchParams()
  const id = searchParams.get("id")
  const sel = searchParams.get("sel")

  const imageUrl = id ? `https://projects.notalepower.com/images/${id}.jpg` : 'https://projects.notalepower.com/images/ZGVmYXVsdA.jpg'
  let name = id ? atob(id) : ''
  
  name = (name.includes('&')) ? name.replace('&',' & ').replaceAll('_',' ') : name.replaceAll('_',' ')
  name = sel ? name.split('&')[sel].trim() : name
  name = (name === 'Bae') ? '💙 ' + name + ' 💙' : name

  return (
    <div className='flex flex-col sm:pt-18 tablet:mx-14 sm:mx-36 px-6 font-sans bg-stone-100 dark:bg-stone-600 dark:text-white'>
            
      <div className='text-sm sm:text-xl text-center dark:bg-stone-600'>
          <div className='px-6 sm:px-32 pt-16 sm:pt-24 flex justify-center'><img src={imageUrl} alt={name} className='rounded-3xl'/></div>
          

          <div className='flex text-lg justify-center pt-2 sm:py-4 font-bold sm:text-5xl dark:text-white'>
            {name}
            </div>
            Thank you for making one of the most important days of my life special.<br/>
            <br/><div className='px-12'><hr className='border-stone-700 dark:border-stone-100'/></div>
        </div>

        <InfoSection title={"Big thanks"}>
            
            <div className='mt-2 text-sm sm:text-xl tablet:px-4 sm:px-20 text-center'>
                
                To those who saw my potential and believed in me from the very beginning.<br/><br/>
                To those who have supported me emotionally and financially during these university years.<br/><br/>
                To those who encouraged me to study even when I didn't want to.<br/><br/>
                <br/><div className='px-6'><hr className='border-stone-700 dark:border-stone-100'/></div><br/><br/>
                To those who helped me with the preparations for the proclamation and the celebration.<br/><br/>
                To those who traveled from afar and to those who set aside other commitments to be present.<br/><br/>
                To everyone who couldn't be there last time but managed to come this time.<br/><br/>
                To those who couldn't make it this time but still made their presence felt.<br/><br/>
                <br/><div className='px-6'><hr className='border-stone-700 dark:border-stone-100'/></div><br/><br/>
                To those who always paid for me so I could be present and spend time together.<br/><br/>
                To those who reached out, even though I was fading away.<br/><br/>
                To those who treated me as if I had never disappeared.<br/><br/>
                <br/><div className='px-6'><hr className='border-stone-700 dark:border-stone-100'/></div><br/><br/>
            </div>

            <div className='text-xs sm:text-lg text-center italic'>
              19-03-2024
            </div>
    
        </InfoSection>
    </div>
  )
}
